import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import orderStateSubscriptionService from '../../services/subscriptions/orderStateSubscriptionService';
import orderTradesSuscriptionService from '../../services/subscriptions/orderTradesSuscriptionService';
import { getOrderEventSnackbar } from '../../helpers/placeOrderHelper';
import { showBuySellSuccessMessage, showBuySellFailMessage } from './orderEntryActions';
import { showSnack } from './snackbarActions';
export var ADD_OPEN_ORDER = 'ADD_OPEN_ORDER';
export var RECEIVE_OPEN_ORDERS = 'RECEIVE_OPEN_ORDERS';
export var REQUEST_OPEN_ORDERS = 'REQUEST_OPEN_ORDERS';
export var ADD_ACCOUNT_TRADE = 'ADD_ACCOUNT_TRADE';
export var RECEIVE_ACCOUNT_TRADES = 'RECEIVE_ACCOUNT_TRADES';
export var REQUEST_ACCOUNT_TRADES = 'REQUEST_ACCOUNT_TRADES';
export var ADD_INACTIVE_ORDER = 'ADD_INACTIVE_ORDER';
export var RECEIVE_INACTIVE_ORDERS = 'RECEIVE_INACTIVE_ORDERS';
export var REQUEST_INACTIVE_ORDERS = 'REQUEST_INACTIVE_ORDERS';
export var RECEIVE_TRADE_REPORTS = 'RECEIVE_TRADE_REPORTS';
export var REQUEST_TRADE_REPORTS = 'REQUEST_TRADE_REPORTS';
export var RECEIVE_TRADE_HISTORY = 'RECEIVE_TRADE_HISTORY';
export var RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID = 'RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID';
export var REMOVE_ACTIVE_REQUEST = 'REMOVE_ACTIVE_REQUEST';
export var initOrderHistorySubscription = function initOrderHistorySubscription(AccountId, OMSId) {
  return function (dispatch) {
    orderStateSubscriptionService.initSubscribtion({
      AccountId: AccountId,
      OMSId: OMSId
    });
    orderTradesSuscriptionService.initSubscribtion({
      AccountId: AccountId,
      OMSId: OMSId
    });
  };
};
export var getOpenOrders = function getOpenOrders(AccountId, OMSID) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var openOrders;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(requestOpenOrders());
              _context.next = 3;
              return dispatch(callAPI('GetOpenOrders', {
                AccountId: AccountId,
                OMSID: OMSID
              }));
            case 3:
              openOrders = _context.sent;
              dispatch(receiveOpenOrders(openOrders));
            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var subscribeToOrderHistory = function subscribeToOrderHistory() {
  return function (dispatch, getState) {
    orderStateSubscriptionService.subscribe(function (x) {
      if (['Working'].some(function (i) {
        return x.OrderState === i;
      })) {
        dispatch(addOpenOrder(x));
        if (getState().form.buySell) {
          dispatch(showBuySellSuccessMessage());
        }
      } else if (['Rejected', 'Canceled', 'FullyExecuted'].some(function (i) {
        return x.OrderState === i;
      })) {
        dispatch(addInactiveOrder(x));
        if (getState().form.buySell) {
          if (x.OrderState === 'FullyExecuted') {
            dispatch(showBuySellSuccessMessage());
          } else {
            dispatch(showBuySellFailMessage());
          }
        }
      }
      var snackBar = getOrderEventSnackbar(x);
      dispatch(showSnack({
        id: 'OrderStateEventSnackbar',
        text: snackBar.text,
        type: snackBar.type,
        textVars: snackBar.textVars
      }));
    });
    orderTradesSuscriptionService.subscribe(function (x) {
      dispatch(addAccountTrade(x));
    });
  };
};
export var getAccountTrades = function getAccountTrades(AccountId, OMSId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var trades;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(requestAccountTrades());
              _context2.next = 3;
              return dispatch(callAPI('GetAccountTrades', {
                AccountId: AccountId,
                OMSId: OMSId,
                Count: 200
              }));
            case 3:
              trades = _context2.sent;
              dispatch(receiveAccountTrades(trades));
              dispatch(receiveTradeHistory(trades));
            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var FetchAccountTradesForOrderId = function FetchAccountTradesForOrderId(OrderId) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var _getState, user, AccountId, trades;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _getState = getState(), user = _getState.user;
              AccountId = user.accounts[0].AccountId;
              _context3.next = 4;
              return dispatch(callAPI('GetAccountTrades', {
                AccountId: AccountId,
                OrderId: OrderId,
                OMSID: 1
              }));
            case 4:
              trades = _context3.sent;
              dispatch(receiveAccountTradesForOrderId(trades));
            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));
    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var getInactiveOrders = function getInactiveOrders(AccountId, OMSId) {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var Depth, orders;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch(requestInactiveOrders());
              Depth = 1000;
              _context4.next = 4;
              return dispatch(callAPI('GetOrderHistory', {
                AccountId: AccountId,
                OMSId: OMSId,
                Depth: Depth
              }));
            case 4:
              orders = _context4.sent;
              dispatch(receiveInactiveOrders(orders));
            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));
    return function (_x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var getOrders = function getOrders(AccountId, OMSId) {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      var Depth, orders;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              dispatch(requestInactiveOrders());
              Depth = 1000;
              _context5.next = 4;
              return dispatch(callAPI('GetOrders', {
                AccountId: AccountId,
                OMSId: OMSId,
                Depth: Depth
              }));
            case 4:
              orders = _context5.sent;
              dispatch(receiveInactiveOrders(orders));
            case 6:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));
    return function (_x6) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var removeActiveRequest = function removeActiveRequest() {
  return {
    type: REMOVE_ACTIVE_REQUEST
  };
};
export var getOpenTradeReports = function getOpenTradeReports(AccountId, OMSId) {
  return function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      var tradeReports;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              dispatch(requestTradeReports());
              _context6.next = 3;
              return dispatch(callAPI('GetOpenTradeReports', {
                AccountId: AccountId,
                OMSId: OMSId
              }));
            case 3:
              tradeReports = _context6.sent;
              dispatch(receiveTradeReports(tradeReports));
            case 5:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this);
    }));
    return function (_x7) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var receiveOpenOrders = function receiveOpenOrders(payload) {
  return {
    type: RECEIVE_OPEN_ORDERS,
    payload: payload
  };
};
export var requestOpenOrders = function requestOpenOrders() {
  return {
    type: REQUEST_OPEN_ORDERS
  };
};
export var addOpenOrder = function addOpenOrder(payload) {
  return {
    type: ADD_OPEN_ORDER,
    payload: payload
  };
};
export var addInactiveOrder = function addInactiveOrder(payload) {
  return {
    type: ADD_INACTIVE_ORDER,
    payload: payload
  };
};
export var receiveAccountTrades = function receiveAccountTrades(payload) {
  return {
    type: RECEIVE_ACCOUNT_TRADES,
    payload: payload
  };
};
export var receiveAccountTradesForOrderId = function receiveAccountTradesForOrderId(payload) {
  return {
    type: RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID,
    payload: payload
  };
};
export var requestAccountTrades = function requestAccountTrades() {
  return {
    type: REQUEST_ACCOUNT_TRADES
  };
};
export var addAccountTrade = function addAccountTrade(payload) {
  return {
    type: ADD_ACCOUNT_TRADE,
    payload: payload
  };
};
export var receiveInactiveOrders = function receiveInactiveOrders(payload) {
  return {
    type: RECEIVE_INACTIVE_ORDERS,
    payload: payload
  };
};
export var requestInactiveOrders = function requestInactiveOrders() {
  return {
    type: REQUEST_INACTIVE_ORDERS
  };
};
export var receiveTradeReports = function receiveTradeReports(payload) {
  return {
    type: RECEIVE_TRADE_REPORTS,
    payload: payload
  };
};
export var requestTradeReports = function requestTradeReports() {
  return {
    type: REQUEST_TRADE_REPORTS
  };
};
export var receiveTradeHistory = function receiveTradeHistory(payload) {
  return {
    type: RECEIVE_TRADE_HISTORY,
    payload: payload
  };
};
export var cancelAllOrders = function cancelAllOrders() {
  return function (dispatch, getState) {
    var OMSId = getState().user.userInfo.OMSId;
    var selectedAccountId = getState().user.selectedAccountId;
    var selectedInstrumentId = getState().apexCore.instrument.selectedInstrumentId;
    dispatch(callAPI('CancelAllOrders', {
      OMSId: OMSId,
      AccountId: selectedAccountId,
      InstrumentId: selectedInstrumentId
    })).then(function () {
      return dispatch(showSnack({
        id: 'cancelAllOrdersSuccessSnack',
        text: 'All orders cancelled',
        type: 'success'
      }));
    });
  };
};
export var cancelSellOrders = function cancelSellOrders() {
  return function (dispatch, getState) {
    cancelSideOrders(dispatch, getState, 'Sell');
  };
};
export var cancelBuyOrders = function cancelBuyOrders() {
  return function (dispatch, getState) {
    cancelSideOrders(dispatch, getState, 'Buy');
  };
};
export var cancelOrders = function cancelOrders(OrderIds) {
  return function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch, getState) {
      var OMSId, selectedAccountId, cancelOrderPromises;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId;
              selectedAccountId = getState().user.selectedAccountId;
              if (!(OrderIds.length > 1)) {
                _context7.next = 13;
                break;
              }
              cancelOrderPromises = OrderIds.map(function (orderId) {
                dispatch(callAPI('CancelOrder', {
                  OrderId: orderId,
                  AccountId: selectedAccountId,
                  OMSId: OMSId
                }));
              });
              _context7.next = 6;
              return Promise.all(cancelOrderPromises);
            case 6:
              _context7.next = 8;
              return dispatch(getOpenOrders(selectedAccountId, OMSId));
            case 8:
              _context7.next = 10;
              return dispatch(getOpenTradeReports(selectedAccountId, OMSId));
            case 10:
              dispatch(showSnack({
                id: 'cancelOrderSuccessSnack',
                // context.t('Orders {n} cancelled')
                text: 'Orders {n} cancelled',
                textVars: {
                  n: OrderIds.toString()
                },
                type: 'success'
              }));
              _context7.next = 20;
              break;
            case 13:
              _context7.next = 15;
              return dispatch(callAPI('CancelOrder', {
                OrderId: OrderIds[0],
                AccountId: selectedAccountId,
                OMSId: OMSId
              }));
            case 15:
              _context7.next = 17;
              return dispatch(getOpenOrders(selectedAccountId, OMSId));
            case 17:
              _context7.next = 19;
              return dispatch(getOpenTradeReports(selectedAccountId, OMSId));
            case 19:
              dispatch(showSnack({
                id: 'cancelOrderSuccessSnack',
                // context.t('Order {n} cancelled')
                text: 'Order {n} cancelled',
                textVars: {
                  n: OrderIds[0]
                },
                type: 'success'
              }));
            case 20:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this);
    }));
    return function (_x8, _x9) {
      return _ref7.apply(this, arguments);
    };
  }();
};
function cancelSideOrders(dispatch, getState, side) {
  var openOrders = getState().apexCore.orderHistory.openOrders;
  var OMSId = getState().user.userInfo.OMSId;
  var selectedAccountId = getState().user.selectedAccountId;
  var sideOrderIds = openOrders.filter(function (order) {
    return order.Side === side;
  }).map(function (order) {
    return order.OrderId;
  });
  sideOrderIds.forEach(function (OrderId) {
    dispatch(callAPI('CancelOrder', {
      OrderId: OrderId,
      AccountId: selectedAccountId,
      OMSId: OMSId
    }));
  });
  if (side === 'Buy') {
    dispatch(showSnack({
      id: 'cancelBuyOrdersSuccessSnack',
      text: 'Buy orders cancelled',
      type: 'success'
    }));
  } else {
    dispatch(showSnack({
      id: 'cancelSellOrdersSuccessSnack',
      text: 'Sell orders cancelled',
      type: 'success'
    }));
  }
}